module.exports = __webpack_public_path__ + "img/logo_beratungsring.1f47de5a.png";